import { apiGetRequest } from '@/utils/apiClient';
import { saveLoginInfoToStorage } from '@/utils/loginInfo';

export type CalendarOauthReadiness = {
    ready: boolean;
    reauthorizePath?: string;
};

/**
 * 自動配信ON前に、オフラインでカレンダーAPIを呼ぶためのリフレッシュトークンが足りるか確認する
 */
export async function fetchCalendarOauthReadiness(calendarId?: string | null): Promise<CalendarOauthReadiness> {
    const q =
        calendarId != null && calendarId !== ''
            ? `?calendarId=${encodeURIComponent(calendarId)}`
            : '';
    const res = await apiGetRequest(`/api/delivery/calendar-oauth-readiness${q}`);
    if (res.status === 404) {
        throw new Error('CALENDAR_OAUTH_READINESS_NOT_FOUND');
    }
    if (!res.ok) {
        throw new Error(`calendar oauth readiness failed: ${res.status}`);
    }
    return (await res.json()) as CalendarOauthReadiness;
}

/**
 * バックエンドの OAuth リゾルバが Referer なしでも配信ページ用の consent/offline を付与できるようクエリを付与する
 */
export function redirectToCalendarReauth(reauthorizePath: string): void {
    saveLoginInfoToStorage();
    const sep = reauthorizePath.includes('?') ? '&' : '?';
    window.location.href = `${reauthorizePath}${sep}from=delivery`;
}
